'use client';

import styled, { TColorProp } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';

export type TTitleSize = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface IContainerProps {
  $size: TTitleSize;
  $color: TColorProp;
}

const getLineHeight = {
  h1: 64,
  h2: 56,
  h3: 48,
  h4: 40,
  h5: 32,
  h6: 28,
} as Record<TTitleSize, number>;

const getFontSize = {
  h1: 56,
  h2: 48,
  h3: 40,
  h4: 32,
  h5: 24,
  h6: 20,
} as Record<TTitleSize, number>;

const getLetterSpacing = (size: TTitleSize): number => {
  const fontSize = getFontSize[size];
  const percentage = (
    {
      h1: -1,
      h2: -1,
      h3: -1,
      h4: -0.5,
      h5: 0,
      h6: 0,
    } as Record<TTitleSize, number>
  )[size];

  return (fontSize * percentage) / 100;
};

export const Container = styled.h1<IContainerProps>`
  line-height: ${({ $size }) => getLineHeight[$size]}px;
  font-size: ${({ $size }) => getFontSize[$size]}px;
  letter-spacing: ${({ $size }) => getLetterSpacing($size)}px;
  font-weight: 500;
  color: ${({ theme, $color }) => getThemeColor(theme, $color)};
`;
